import { render, staticRenderFns } from "./privilegeList.vue?vue&type=template&id=60253dd4&scoped=true"
import script from "./privilegeList.vue?vue&type=script&lang=js"
export * from "./privilegeList.vue?vue&type=script&lang=js"
import style0 from "./privilegeList.vue?vue&type=style&index=0&id=60253dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60253dd4",
  null
  
)

export default component.exports